// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"e6e0b7ba","138":"e2e89617","270":"dd666a81","387":"4d61303c","404":"7dae82bf","488":"b2a64b34","545":"9146737d","580":"21306759","686":"76554b53","706":"44ba4c26","728":"c11e0b30","801":"94c55834","888":"ad81de81"}[chunkId] + ".chunk.js";
};